import {autorun} from "mobx";
import {AutoRun_HandleBail, CreateAccessor} from "mobx-graphlink";
import {store} from "../../../Store/index.js";
import {GetSelectedEngineConfig} from "../../../Server/DB/engineConfigs.js";
import {GetOpenSession} from "../../../Server/DB/sessions.js";
import {IsSessionUIOpen, SessionUITab} from "../../../Store/main/timeline.js";
import {OnStoreLoaded} from "../../../Utils/General/GlobalHooks.js";
import {SessionDataProcessor} from "./SessionDataProcessor.js";
import {GetSelectedSessionExternals, SessionExternals} from "../../../Store/main/timeline/SessionDerivativeData.js";
import {computed} from "mobx";
import {O, RunInAction} from "web-vcore";
import {ignore} from "mobx-sync";

export class SessionProcessorsState {
	@O @ignore accessor orig: SessionDataProcessor|n;
	@O @ignore accessor resim: SessionDataProcessor|n;
	@computed get Active() {
		const uiState = store.main.timeline.sessions;
		return uiState.processing_useCurrentConfig ? this.resim : this.orig;
	}
	@computed get Inactive() {
		const uiState = store.main.timeline.sessions;
		return uiState.processing_useCurrentConfig ? this.orig : this.resim;
	}
}

export const GetSessionProcessors = CreateAccessor(()=>{
	return store.main.timeline.sessions.processors;
});

OnStoreLoaded(()=>{
	// keep detail-panel processors up-to-date with engine-config
	AutoRun_HandleBail(()=>{
		const uiState = store.main.timeline.sessions;
		const processors = uiState.processors;
		const session = GetOpenSession();
		if (session == null) {
			// clear processor data, when leaving/closing session-ui
			/*sessionProcessor_orig.Init_Empty();
			sessionProcessor_resim.Init_Empty();*/
			RunInAction("SessionProcessorsState_Clear", ()=>{
				processors.orig = null;
				processors.resim = null;
			});
			return;
		}
		//if (!session._local) return; // wait till local-data for session comes in (and if non-existent, we can't do processing anyway)

		const currentConfig = GetSelectedEngineConfig();
		if (currentConfig == null) return;
		const sessionExt = GetSelectedSessionExternals();
		if (sessionExt == null) return;
		// if we're not on a page that cares about the detail-panel eeg-processor, delay the effects (updating options, and starting/resetting processing)
		if (!IsSessionUIOpen(SessionUITab.details)) return;

		// if selected-session changed, recreate session-data-processors
		RunInAction("SessionProcessorsState_ReactToLatestConfigAndData", ()=>{
			if (processors.orig == null || (processors.orig.loadedSessionData?.session && session != processors.orig.loadedSessionData?.session)) {
				processors.orig = new SessionDataProcessor();
			}
			if (processors.resim == null || (processors.resim.loadedSessionData?.session && session != processors.resim.loadedSessionData?.session)) {
				processors.resim = new SessionDataProcessor();
			}
		});
		// tell active processor to use current settings (can trigger clearing of cached data)
		const useResim = uiState.processing_useCurrentConfig;
		/*sessionProcessor_active.UpdateConfig(useResim ? currentConfig : session.config, {
			performResim: useResim,
			eegAndGyro_normalize: uiState.eeg_normalize,
			eegAndGyro_smooth: uiState.eeg_smooth,
			clearOutOfRangeCache: true,
		});
		// if active processor has not yet had its raw-data populated, do so
		if (sessionProcessor_active.loadedSessionData == null) {
			sessionProcessor_active.Init_SavedSession(session, sessionExt);
		}*/

		processors.Active!.PossiblyRecalcFromLatestConfigAndData(
			useResim ? currentConfig : session.config,
			{
				performResim: useResim,
				eegAndGyro_normalize: uiState.eeg_normalize,
				eegAndGyro_smooth: uiState.eeg_smooth,
				clearOutOfRangeCache: true,
				longInhaleDebug_startTime: uiState.longInhaleDebug_startTime,
				longInhaleDebug_endTime: uiState.longInhaleDebug_endTime,
			},
			session,
			sessionExt,
		);
	});
	// keep active processor up-to-date with current-time (and update processorTimer.Enabled states)
	AutoRun_HandleBail(()=>{
		const uiState = store.main.timeline.sessions;
		const {processors, viewRange_startTime, viewRange_endTime} = uiState; // access these vals before check, so we always react to their changes

		if (processors.Active == null || processors.Inactive == null) return;
		// tell active processor to enable its processing-timer, and inactive one to disable its
		processors.Active.processingTimer.Enabled = !processors.Inactive.processingComplete;
		processors.Inactive.processingTimer.Enabled = false;

		const sessionData = GetSelectedSessionExternals();
		//if (detailPanelEEGProcessor.sampleIndexesForSeconds == null) return; // data not yet loaded
		if (sessionData == null) return; // data not yet loaded
		if (processors.Active.loadedSessionData?.session?.id != sessionData.sessionID) return; // if in middle of loaded-session update

		const visibleRange_startSampleIndex = processors.Active.eegProcessor.GetSampleIndexForTime(viewRange_startTime, true);
		const visibleRange_endSampleIndex = processors.Active.eegProcessor.GetSampleIndexForTime(viewRange_endTime, true);
		const visibleRange_centerSampleIndex = visibleRange_startSampleIndex != null && visibleRange_endSampleIndex != null
			? Math.floor((visibleRange_startSampleIndex + visibleRange_endSampleIndex) / 2)
			: null;
		if (visibleRange_centerSampleIndex == null) return; // if no valid sample-index for the current time

		processors.Active.SetViewCenter(visibleRange_centerSampleIndex);
	});
});